import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import type {AgendaV3} from "crqlar-react-common/dist/models/agenda/agenda.model";
import {useTranslation} from "react-i18next";
import {type RadioFilterOption, RadioFilterPanel} from "../../layout/rightSidebar/RadioFilterPanel";
import {RightSidebarPanelButton} from "../../layout/rightSidebar/RightSidebarRail";

export interface WeeklyPlannerAgendaPickerProps {
    agendas: readonly AgendaV3[];
    selectedAgendaId: string;
    onSelectedAgendaIdChange: (agendaId: string) => void;
}

export function WeeklyPlannerAgendaPicker({
                                              agendas,
                                              selectedAgendaId,
                                              onSelectedAgendaIdChange,
                                          }: WeeklyPlannerAgendaPickerProps) {
    const {t} = useTranslation();
    const options = agendas.reduce<RadioFilterOption<string>[]>((result, agenda) => {
        if (!agenda.id) return result;

        result.push({
            value: agenda.id,
            label: agenda.name || t("unnamed"),
        });
        return result;
    }, []);

    return (
        <RightSidebarPanelButton
            icon={<CalendarMonthOutlinedIcon/>}
            label={t("Weekly Planner")}
            disabled={options.length === 0}
            renderPanel={close => (
                <RadioFilterPanel<string>
                    title={t("Weekly Planner")}
                    options={options}
                    value={selectedAgendaId}
                    onChange={onSelectedAgendaIdChange}
                    onClose={close}
                />
            )}
        />
    );
}
